export const FREE_SCENARIO_IDS = [
    '0ba81110-88c9-46dd-8f48-50a7d301e14f',
    '22a12eb9-07d6-4ccf-a5f3-47f405b83285',
    '2f4018f3-86b1-4f36-aa79-10ff586ccca6',
    '393a5a34-e486-425c-ba5c-fc41c3b7cdb4',
    '4a947fbd-c283-4121-8547-712d80626f45',
    '90647a4a-04be-4be0-8f2c-dc25745ade47'
  ];